import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import HttpStatus from 'ha/constants/HttpStatus';
import reportError from 'ha/helpers/bugsnag/reportError';
import { UserApiV2 } from 'ha/services/apiV2/types/User';
import { changeLocation } from 'ha/modules/URLLocationHandler';
import { ImpersonateUserTypes } from '../constants';

type Id = number;

export const Actions = {
  start: (id: Id) => createAction(ImpersonateUserTypes.start, id),
  done: (data: UserApiV2) => createAction(ImpersonateUserTypes.done, data),
  fail: () => createAction(ImpersonateUserTypes.fail),
};

export type Actions = ActionsUnion<typeof Actions>;

const impersonateUser = (id: Id, nextUrl: string): Thunk => (
  dispatch,
  _,
  { apiV2 },
) => {
  dispatch(Actions.start(id));

  return apiV2
    .impersonateUser(id)
    .then(({ data }) => {
      dispatch(Actions.done(data));
      dispatch(changeLocation(nextUrl));
    })
    .catch(error => {
      dispatch(Actions.fail());

      if (error.cause.status === HttpStatus.INTERNAL_SERVER_ERROR) {
        reportError('Impersonation failed', { metaData: { error } });
      }
    });
};

export default impersonateUser;
